export default function MetricCardCompact({
  label,
  value,
  helper,
  icon: Icon = null,
  tone = 'default',
  className = '',
}) {
  const toneClassName = {
    success: 'border-[rgba(var(--success),0.2)] bg-[rgba(var(--success),0.08)]',
    warning: 'border-[rgba(var(--warning),0.22)] bg-[rgba(var(--warning),0.08)]',
    danger: 'border-[rgba(var(--danger),0.2)] bg-[rgba(var(--danger),0.08)]',
    brand: 'border-[rgba(var(--brand),0.22)] bg-[rgba(var(--brand),0.08)]',
    default: 'border-[rgba(var(--border),0.58)] bg-[rgba(var(--panel),0.96)]',
  }[tone] || 'border-[rgba(var(--border),0.58)] bg-[rgba(var(--panel),0.96)]';

  return (
    <article className={`rounded-2xl border px-3 py-2 shadow-[0_10px_24px_rgba(var(--shadow),0.08)] ${toneClassName} ${className}`.trim()}>
      <div className="flex items-center justify-between gap-2">
        <span className="text-[10px] font-semibold uppercase tracking-[0.16em] text-[rgba(var(--muted),0.9)]">
          {label}
        </span>
        {Icon ? <Icon size={14} aria-hidden="true" className="text-[rgba(var(--fg),0.54)]" /> : null}
      </div>
      <div className="mt-1 text-lg font-semibold leading-none text-[rgb(var(--fg))]">{value}</div>
      {helper ? <div className="mt-1 text-[11px] text-[rgba(var(--muted),0.9)]">{helper}</div> : null}
    </article>
  );
}
